import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { SOUND_EFFECTS } from '@/constants';

const initialState = {
  enabled: SOUND_EFFECTS.CONFIG.enabled,
  tooltipEnabled: SOUND_EFFECTS.CONFIG.tooltipEnabled,
  messageSendEnabled: SOUND_EFFECTS.CONFIG.messageSendEnabled,
  liveAgentMessageEnabled: SOUND_EFFECTS.CONFIG.liveAgentMessageEnabled,
  volume: SOUND_EFFECTS.CONFIG.volume,
};

export const useSoundStore = create(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        setEnabled: (enabled) => set({ enabled }),
        toggleEnabled: () => set((state) => ({ enabled: !state.enabled })),
        setTooltipEnabled: (tooltipEnabled) => set({ tooltipEnabled }),
        setMessageSendEnabled: (messageSendEnabled) => set({ messageSendEnabled }),
        setLiveAgentMessageEnabled: (liveAgentMessageEnabled) => set({ liveAgentMessageEnabled }),
        setVolume: (volume) => set({ volume }),
        setSettings: (settings) =>
          set((state) => {
            const updates = typeof settings === 'function' ? settings(state) : settings || {};
            return { ...state, ...updates };
          }),
        reset: () => set({ ...initialState }),
      }),
      {
        name: 'sound-store',
        storage: createJSONStorage(() => localStorage),
        version: 1,
      }
    )
  )
);
